module.exports = "/v2/pages/dashboard/dist/91aaae64cbc22fb8ef8ae89d5526abaa.svg";